module.exports = __webpack_public_path__ + "static/media/UneteExtrasMobile.0aa15f4a.svg";